import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { formatPrice } from '../../lib/format';
import { getProductCardImage } from '../../lib/images';

const ProductCard = ({ product, theme, onAddToCart, onMouseEnter }) => {
  const cardImage = getProductCardImage(product);
  const slug = product.slug || product._id || product.id;
  const realm = product.category || theme?.id;
  const href = realm && slug ? `/${realm}/${slug}` : '#';
  const isOOS = product.inStock === false || product.totalStock === 0;
  const onSale = product.salePrice && product.salePrice < product.price;

  return (
    <Link
      to={href}
      onMouseEnter={onMouseEnter}
      className={`group relative flex flex-col bg-white border-4 ${theme?.colors?.border || 'border-black'} shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-2 hover:translate-y-2 transition-all duration-200 ${theme?.shape || ''} overflow-hidden`}
    >
      {product.tag && (
        <div className="absolute top-4 left-4 z-20 bg-red-600 text-white text-xs font-black px-3 py-1 border-2 border-black transform -rotate-3 shadow-[2px_2px_0px_black]">
          {product.tag}
        </div>
      )}
      {product.tags?.length > 0 && !product.tag && (
        <div className="absolute top-4 left-4 z-20 bg-red-600 text-white text-xs font-black px-3 py-1 border-2 border-black transform -rotate-3 shadow-[2px_2px_0px_black]">
          {product.tags[0]}
        </div>
      )}

      {isOOS && (
        <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/40">
          <div className="bg-white text-black px-4 py-2 font-black uppercase tracking-widest border-4 border-black -rotate-3">
            Sold Out
          </div>
        </div>
      )}

      <div className={`h-96 w-full border-b-4 ${theme?.colors?.border || 'border-black'} flex items-center justify-center bg-gray-100 relative overflow-hidden cursor-pointer`}>
        <div className="absolute inset-0 opacity-10 bg-[repeating-linear-gradient(45deg,transparent,transparent_10px,#000_10px,#000_11px)]"></div>
        {cardImage ? (
          <img
            src={cardImage}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform group-hover:scale-110"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        ) : (
          <span className={`text-[12rem] font-black opacity-10 ${theme?.colors?.text || 'text-black'} absolute -bottom-10 -right-10`}>
            {product.name?.charAt(0)}
          </span>
        )}

        {onAddToCart && !isOOS && (
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100 backdrop-blur-[2px]">
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onAddToCart(product);
              }}
              className="transform scale-110 bg-yellow-400 text-black px-8 py-4 font-black border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:bg-white hover:scale-125 transition-all uppercase flex items-center gap-2"
            >
              <ShoppingBag size={20} /> QUICK ADD
            </button>
          </div>
        )}
      </div>

      <div className="p-5 flex flex-col flex-grow justify-between bg-white relative">
        <div className="absolute top-0 left-0 w-full h-1 bg-black transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500"></div>
        <div>
          <div className="mb-2">
            <span className="bg-black text-white px-2 py-1 text-[10px] font-black uppercase tracking-widest border border-transparent group-hover:border-white transition-all shadow-[2px_2px_0px_rgba(255,255,255,0.5)]">
              COLLECTION // {product.type || 'Drop'}
            </span>
          </div>
          <h3 className={`text-2xl font-black leading-none mb-2 ${theme?.colors?.text || 'text-black'} uppercase`}>
            {product.name}
          </h3>
        </div>
        <div className="flex justify-between items-end mt-6">
          <div className="flex flex-col">
            <span className="text-3xl font-black">{formatPrice(product.salePrice ?? product.price)}</span>
            {onSale && (
              <span className="text-sm line-through opacity-50 font-mono">{formatPrice(product.price)}</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
